import { TextRoller } from "../../animations";
import { For, splitProps } from "solid-js";
import type { MainProps } from "./_model";

export default function Platform(props: MainProps) {
  const [local, others] = splitProps(props, ["title", "msg"]);
  return (
    <div {...others} class={`text-1rem <md:text-0.67rem w-full ${others.class ?? ""}`}>
      <TextRoller word={local.title} containerClass="flex flex-row !w-fit !h-fit !text-justify" />
      <For each={local?.msg?.split("\n")}>
        {(item) => {
          return <p class="text-1rem pt-4 <md:(text-0.7rem pt5) ">{item}</p>;
        }}
      </For>
    </div>
  );
}
